import React from 'react';

import Popup from "reactjs-popup";
import SignatureCanvas from "react-signature-canvas";

const FirmaAutocertificazione = ({
    anteprima, 
    imageURL,
    sigCanvas,
    cancellaFirma,
    clearSig,
    saveSig
    }) => {

    return (
        <div className='firmaBox'>
            <div>Firma del/la dichiarante (per esteso e leggibile)</div>
            <div style={anteprima ? {display:'none'} : {display:'unset'} }>
                <Popup
                modal
                trigger={<button className='bottoniCertPopup'>{imageURL ? (
                <>
                    <img
                        src={imageURL}
                        alt="firma autocertificazione"
                        style={{
                        display: "block",
                        margin: "0 auto",
                        width: "150px"
                        }}
                    />
                </>
                ) : 'Inserisci'}</button>}
                closeOnDocumentClick={false}
                >
                {close => (
                    <div className='boxCanvas'>
                        <SignatureCanvas
                            ref={sigCanvas}
                            penColor="black"
                            canvasProps={{ width: 700, height: 400, className: "signatureCanvas" }}
                        />
            
                        <div className='sigButton'>
                        {
                            imageURL ? 
                            <>
                                {cancellaFirma ? 
                                <>
                                <img
                                src={imageURL}
                                alt="firma autocertificazione"
                                style={{
                                    display: "block",
                                    margin: "0 auto",
                                    width: "150px"
                                }}/>
                                <button className='bottoniCert' onClick={clearSig}>Cancella</button> 
                                </>
                                :
                                null
                                }
                            </>
                            :
                            <div>Disegna la firma</div>
                        }
                        {!cancellaFirma ? <button className='bottoniCert' onClick={saveSig}>Salva</button> : null}
                        <button className='bottoniCert' onClick={close}>Chiudi</button>
                        </div>
                    </div>
                )}
            </Popup>
            </div>
            {anteprima && imageURL ? (
                <>
                <img
                src={imageURL}
                alt="firma autocertificazione"
                style={{
                    display: "block",
                    margin: "0 auto",
                    width: "150px"
                }}
                />
                </>
            ) : null}
        </div>
        );
    }

export default FirmaAutocertificazione;